<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-3">
        <h3 class="font-weight-bolder mt-3">Covid Vaccines</h3>
      </div>
      <div class="col col-auto pt-3">
        <template v-if="crew.active == 1">
        <AddCovidVaccine v-if="!guest && !isKline"></AddCovidVaccine>
        </template>
      </div>

      <div class="col col-sm-12">
        <MedicalNavigation></MedicalNavigation>
      </div>

      <div class="col col-12">
        <table class="table table-sm table-hover table-bordered text-small text-center"
               style="border-color: lightgray;">
          <thead class="bg-lightgray">
          <tr>
            <!--                    <th :class="{'col-index': !printMultipleParams.active}">-->
            <!--                        <input type="checkbox"-->
            <!--                               v-if="printMultipleParams.active"-->
            <!--                               @change="selectDocuments"-->
            <!--                               :checked="allMedicalSelected"-->
            <!--                        >-->
            <!--                        #-->
            <!--                    </th>-->
            <th>Vaccine Brand</th>
            <th>Inoculated Date</th>
            <th>Completion Date (2nd Dose)</th>
            <th>Administering Country</th>
            <th width="10%">Action</th>
          </tr>
          </thead>
          <tbody>

          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="covidVaccine in covidVaccines" :key="covidVaccine.id">
              <td>{{ covidVaccine.vaccineBrand }}</td>
              <td>
                <span
                    v-if="covidVaccine.inoculate_date">{{ covidVaccine.inoculate_date | moment('DD MMM YYYY') }}</span>
              </td>
              <td>
                <span v-if="!covidVaccine.dose_2 && !covidVaccine.is_booster" class="text-secondary">Not Required</span>
                <span
                    v-else-if="covidVaccine.completion_date">{{
                    covidVaccine.completion_date | moment('DD MMM YYYY')
                  }}</span>
                <span v-else-if="covidVaccine.is_booster">BOOSTER SHOT</span>
              </td>
              <td>{{ covidVaccine.country }}</td>
              <td>
                <button class="btn btn-sm btn-xs btn-outline-info mr-2"
                        data-toggle="modal"
                        data-target="#view-covid-vaccine"
                        @click="viewCovidVaccine = covidVaccine"
                >
                  <span class="fas fa-file-alt"></span>
                  View
                </button>
                <template v-if="crew.active == 1 || isSystemAdmin">
                  <button class="btn btn-sm btn-xs btn-outline-danger" v-if="!guest && !isKline"
                          @click="confirmDeleteCovidVaccine(covidVaccine.id)"
                  >
                    <span class="fas fa-trash"></span>
                  </button>
                </template>
              </td>


            </tr>
          </template>

          </tbody>
        </table>

      </div>

    </div>

    <view-covid-vaccine :view-covid-vaccine="viewCovidVaccine"></view-covid-vaccine>

  </div>
</template>

<script>
/* eslint-disable */
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {dataMixin} from '@/mixins/dataMixin';
import {gateMixin} from '@/mixins/gateMixin';
import {mapActions, mapGetters} from 'vuex';
import {formMixin} from "@/mixins/formMixin";

import AppLoading from "@/components/elements/AppLoading";
import MedicalNavigation
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/MedicalNavigation";
import AddCovidVaccine
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/covid_vaccine/AddCovidVaccine";
import ViewCovidVaccine
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/covid_vaccine/ViewCovidVaccine";

export default {
  name: "CovidVaccineIndex",

  mixins: [vueAppMixin, formMixin, dataMixin, gateMixin],

  components: {MedicalNavigation, AppLoading, AddCovidVaccine, ViewCovidVaccine},

  data() {
    return {
      viewCovidVaccine: {}
    }
  },

  methods: {
    ...mapActions([
      'getVaccineBrandKeys',
      'getCountryKeys',
      'getCovidVaccines',
      'deleteCovidVaccine'
    ]),

    async confirmDeleteCovidVaccine(covidVaccineId) {
      if (await this.confirmDeleteAlert()) {
        let params = {
          covidVaccineId: covidVaccineId
        };
        let deletedCovidVaccine = await this.deleteCovidVaccine(params);
        if (deletedCovidVaccine) {
          this.successAlert('Covid Vaccine Record Successfully Deleted', 'DELETE');
        }
      }
    }

  },

  computed: {
    ...mapGetters([
      'crew',
      'covidVaccines'
    ])
  },

  created() {
    this.getVaccineBrandKeys();
    this.getCountryKeys();
    if (this.crew.id) {
      this.getCovidVaccines({crewId: this.crew.id});
    }
  },

  watch: {
    'crew.id'() {
      this.getCovidVaccines({crewId: this.crew.id});
    }
  }

}
</script>

<style scoped>
* {
  font-family: 'Nunito', sans-serif;
}

.bg-lightgray {
  background: lightgray;
}

.col-table-2 tr td:first-child {
  font-weight: bold;
}

.modal-lg {
  max-width: 1000px;
}

</style>